/**
 * Whether this is a phone or tablet, rather than a narrow desktop window.
 *
 * Deliberately not `menuState.isMobile`: that is a 1024px layout breakpoint, so
 * a resized desktop browser trips it. This answers "can the OS share sheet hand
 * a file to WhatsApp", which is a property of the device, not of the viewport.
 */
export const isPhoneDevice = (): boolean => {
    const uaData = (navigator as any).userAgentData;
    if (typeof uaData?.mobile === 'boolean') return uaData.mobile;

    // iPadOS 13+ reports itself as a Mac, so touch points are the giveaway.
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;

    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|BlackBerry/i.test(navigator.userAgent);
};
